import React from 'react';
import PropTypes from 'prop-types';
import { Button, Alert, Divider } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FieldArray } from 'formik';

import { Form as FormikForm } from 'formik-antd';

import qualifications from 'utils/qualifications';

import { Fieldset } from 'components/form';

import StagePropTypes from './prop-types';
import { DB_PREFIX_JOBS } from './constants';
import QualificationInput from './qualification-input';
import Row from './row';

const Form = ({
  children,
  values,
  setFieldValue,
  uploadTo,
  isSubmitting,
  errors,
}) => {
  return (
    <FormikForm layout="vertical">
      <Alert
        message="Add any relevant qualifications"
        description="Your employer will need to know you have the relevant skills and experience to support their service users/residents. If you upload a document to the wrong section, simply click on the ‘Upload new’ button again and it will delete it for you."
        type="info"
        showIcon
      />

      <h2>Job Roles</h2>

      <FieldArray
        name={DB_PREFIX_JOBS}
        render={(arrayHelpers) => (
          <>
            {values[DB_PREFIX_JOBS].map((qualification, i) => {
              return (
                <Row
                  key={i}
                  i={i}
                  values={values}
                  arrayHelpers={arrayHelpers}
                  setFieldValue={setFieldValue}
                />
              );
            })}

            {values[DB_PREFIX_JOBS].length === 0 ? (
              <Fieldset>
                <Button
                  style={{ width: '100%' }}
                  type="dashed"
                  onClick={() =>
                    arrayHelpers.push({
                      sector: '',
                      role: '',
                    })
                  }
                >
                  <PlusOutlined /> Add job role
                </Button>
              </Fieldset>
            ) : null}
          </>
        )}
      />

      <Divider />

      <h2>Qualifications</h2>

      {qualifications.map((qualification) => {
        return (
          <QualificationInput
            key={qualification.name}
            values={values}
            uploadTo={uploadTo}
            setFieldValue={setFieldValue}
            isSubmitting={isSubmitting}
            errors={errors}
            {...qualification}
          />
        );
      })}

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  uploadTo: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}).isRequired,
};

Form.defaultProps = {
  children: null,
};

export default Form;
